import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhatWeDo } from './components/WhatWeDo';
import { Products } from './components/Products';
import { Benefits } from './components/Benefits';
import { WhyUs } from './components/WhyUs';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Philosophy } from './components/Philosophy';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-[#0d0d0f] font-sans antialiased selection:bg-violet-500/30" data-id="element-0" data-mp="2mmlvl877gb6d">
      <Header data-id="element-1" data-mp="31bs1tg4gn1nr" />
      <main data-id="element-2" data-mp="31bi8bik7icdb">
        <Hero data-id="element-3" data-mp="31c1j8fbfw0hu" />
        <WhatWeDo data-id="element-4" data-mp="31cjn9y4cfj0b" />
        <Products data-id="element-5" data-mp="2wka20ve6b74d" />
        <Benefits data-id="element-6" data-mp="2wjqgz5t882m4" />
        <WhyUs data-id="element-7" data-mp="2wj8ehrfz0s5r" />
        <Testimonials data-id="element-8" data-mp="2wip5j08ate3v" />
        <CTA data-id="element-9" data-mp="2wi5m1f302hnq" />
        <Philosophy data-id="element-10" data-mp="28u5xmlt5v3cb" />
      </main>
      <Footer data-id="element-11" data-mp="28te4dhn1dhp7" />
    </div>;
}